import { DEFAULT_WITH } from '@components/constants';

export const inputWidth = (width?: string, fullWidth?: boolean): string => {
  if (width !== undefined) {
    return width;
  } else if (fullWidth !== undefined && fullWidth) {
    return '100%';
  } else {
    return `${DEFAULT_WITH}px`;
  }
};
